import { Link } from 'react-router-dom';
import { FiExternalLink } from 'react-icons/fi';

const HomeCardLink = ({ to, title, subtitle }) => {
    return (
        <div className="cardItem">
            <Link to={to} target="_black" className="cardItemLink">
                <div className="cardTextContainer">
                    <div className="home-card-icon-wrap" aria-hidden>
                        <FiExternalLink size={22} />
                    </div>
                    <p className="cardTitle mb-0">{title}</p>
                    <p className="cardSubtitle mb-0">{subtitle}</p>
                </div>
            </Link>
        </div>
    );
};

export default HomeCardLink;
